import { ThemeUICSSObject, responsive, spacing } from '@apia/theme';

const oneColumnAside: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(5),
  position: 'sticky',
  top: 0,
  maxWidth: 'applicationMenu',
  overflow: 'auto',
  height: 'min-content',

  '.actionButton': {
    px: 2,
  },
  '.asidePanel': {
    border: 'none',
    padding: 0,
    m: spacing(0),
    display: 'flex',
    flexDirection: 'column',

    '&.responsive': {
      display: responsive({ 0: 'flex', 3: 'none' }),
    },

    '.asidePanel__content': {
      display: 'grid',
      gridTemplateColumns: responsive({ 0: '1fr', 2: '1fr' }),
      gap: spacing(3),

      '& > .twoColumns': {
        gridColumn: responsive({ 0: '1', 2: '1' }),
        gap: spacing(3),
      },
    },

    legend: {
      pt: spacing(2),
      width: '100%',
      fontWeight: 'bold',
      fontSize: '1.2em',
      mb: spacing(5),
      borderBottom: '1px solid',
      borderBottomColor: 'palette.border.section',
    },

    '.additionalFilter': {
      gap: spacing(3),

      '& > div': {
        width: '100%',
      },
    },

    '& label': {
      alignItems: 'stretch',
      display: 'flex',
      flexDirection: 'column',

      'input,select': {
        width: '100%',
      },
    },
  },

  hamburguerButton: {
    zIndex: 'menu',
  },

  hamburguerMenu: {
    background: 'palette.background.paper',
    p: spacing(7),
    border: '1px solid',
    borderColor: 'palette.border.article',
    zIndex: 'menu',

    '.ApplicationMenu': {
      width: 'applicationMenu',
    },
  },

  floatingResponsive: {
    position: 'fixed',
    top: 0,
    transition: 'top 0.3s',
    width: '100%',

    '&.hidden': {
      top: '-100%',
    },

    '.floatingMenu__content': {
      '& > div': {
        width: '100%',
        px: 7,
        overflow: 'auto',
        display: 'flex',
        justifyContent: 'center',
      },

      '.ApplicationMenu': {
        maxWidth: 'applicationMenu',
        width: '100%',
        px: 0,
        mx: 'auto',
        maxHeight: '80vh',
        overflow: 'auto',
      },
    },
  },

  bodyAside: {
    background: 'palette.background.paper',
    p: spacing(7),
    mx: 'auto',

    '& > .ApplicationMenu': {
      mx: 'auto',
      maxWidth: 'applicationMenu',
      width: '100%',
    },
  },
};

export default oneColumnAside;
